export const AutoCompleteList = (arr: any[], search: any): any[] => {
  const newList = arr
    ?.map((item) => item[search])
    ?.sort((a, b) => {
      if (!a || !b) return;
      if (typeof a !== "object") {
        if (a?.toLowerCase() > b?.toLowerCase()) return 1;
        if (a?.toLowerCase() < b?.toLowerCase()) return -1;
        return 0;
      } else {
        if (a?.map((itemA) => itemA?.toLowerCase()) > b?.map((itemB) => itemB?.toLowerCase())) return 1;
        if (a?.map((itemA) => itemA?.toLowerCase()) < b?.map((itemB) => itemB?.toLowerCase())) return -1;
        return 0;
      }
    });

  let listNew = getItemsNormalOrInList(newList);

  let listaFinal = putItemsInList(listNew);

  return listaFinal;
};

function getItemsNormalOrInList(newList: any[]): any[] {
  if (!newList) return [];
  let listNew = [];

  for (let item of newList) {
    if (typeof item === "string") listNew.push(item);
    else item?.forEach((items) => listNew.push(items));
  }
  return listNew;
}

function putItemsInList(list: any[]) {
  const res = new Set(list);

  let listNew = [];
  for (let item of res) {
    listNew.push(item);
  }
  return listNew;
}
